import React from 'react'
// libs
import styled from 'styled-components'
import { reduxForm, InjectedFormProps } from 'redux-form'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import { SketchColorPicker } from 'components/FormElements/ReduxForm'
import HeaderOrigin from 'components/UI/Modal/Header'
// constants
import { Forms } from 'constants/index'
// themes
import { colors } from 'themes/index'
import { CloseIcon } from 'components/UI/Icons'
// utils
import { ellipsis } from 'polished'

// styled
const Header = styled(HeaderOrigin)`
  && {
    align-items: flex-end;
    background: ${colors.darkBlue500};
    display: flex;
    font-size: 20px;
    height: 64px;
    padding: 16px;

    & > span {
      ${ellipsis('90%')};
    }

    > svg {
      margin-right: 8px;
    }
  }
`

const ColorPickerWrapper = styled('div')`
  display: flex;
  justify-content: center;
  margin: 16px 0;
`

const ButtonsSection = styled('div')`
  background-color: ${colors.gray200};
  padding: 8px;

  > div {
    margin-left: 8px;
  }
`

// types
interface Props {
  hideModal: () => void
}

const ObjectiveColorPickerForm: React.FC<InjectedFormProps & Props> = ({ handleSubmit, hideModal }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Header>
        Select a Colour for this Objective Level
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <ColorPickerWrapper>
        <SketchColorPicker name={'color'} />
      </ColorPickerWrapper>
      <ButtonsSection>
        <Button type={'submit'} layout={BUTTON_LAYOUTS.PURPLE} shadowLess>
          Save
        </Button>
        <Button type={'button'} layout={BUTTON_LAYOUTS.PURPLE_INVERTED} shadowLess onClick={hideModal}>
          Cancel
        </Button>
      </ButtonsSection>
    </form>
  )
}

export default reduxForm<any, any>({ form: Forms.OBJECTIVE_SET_COLOR_FORM, enableReinitialize: true })(
  ObjectiveColorPickerForm
)
